const rankingItems = [
  { rank: 1, title: '51黑料最新发布合集 — 本周最热', hot: '9.8万', tag: '爆款', color: 'primary' as const },
  { rank: 2, title: '91黑料网独家内容更新 — 吃瓜速递', hot: '8.5万', tag: '热门', color: 'primary' as const },
  { rank: 3, title: '17黑料地址最新入口导航汇总', hot: '7.2万', tag: '推荐', color: 'accent' as const },
  { rank: 4, title: '718黑料合集 — 一周精彩回顾特辑', hot: '6.8万', tag: '精选', color: 'secondary' as const },
  { rank: 5, title: '黑料51本周讨论热度最高话题', hot: '5.9万', tag: '热议', color: 'secondary' as const },
  { rank: 6, title: '91黑料吃瓜 — 最新实况追踪更新', hot: '5.1万', tag: '新', color: 'primary' as const },
  { rank: 7, title: '17黑料吃瓜视频合集 — 热门回顾', hot: '4.6万', tag: '回顾', color: 'secondary' as const },
];

const colorMap = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', badge: 'bg-primary-500 text-background-50' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', badge: 'bg-accent-500 text-background-50' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', badge: 'bg-secondary-500 text-background-50' },
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">人气榜单</h2>
          <p className="mt-2 text-sm text-foreground-600">51黑料 · 91黑料 · 17黑料 实时热度追踪</p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {rankingItems.map((item, idx) => {
            const c = colorMap[item.color];
            return (
              <div
                key={idx}
                className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-colors group cursor-pointer"
              >
                <div className={`w-9 h-9 flex items-center justify-center rounded-lg font-bold text-sm ${
                  idx < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-foreground-800 truncate group-hover:text-primary-600 transition-colors">{item.title}</h3>
                </div>
                <span className={`px-2 py-1 rounded-md text-xs font-medium whitespace-nowrap ${c.badge}`}>{item.tag}</span>
                <span className="w-16 text-right text-xs font-bold text-primary-500 whitespace-nowrap">{item.hot}</span>
                <span className="w-6 h-6 flex items-center justify-center text-foreground-400">
                  <i className="ri-arrow-right-s-line text-lg"></i>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}